import React, { Component } from 'react'

/* Style */
import './PublicHome.css'

/* Images */
import publicHomeImg01 from '../img/carousel-01.jpg'
import publicHomeImg02 from '../img/carousel-02.jpg'
import publicHomeImg03 from '../img/carousel-03.jpg'
import publicHomeImg04 from '../img/carousel-04.jpg'
import publicHomeImg05 from '../img/carousel-05.jpg'
import publicHomeImg06 from '../img/carousel-06.jpg'

/* Components */
import PublicHomeView from './PublicHomeView'

class PublicHome extends Component {

	constructor(props){
        super(props)
        this.state = { }
	}
	
	componentDidMount = () => {
		window.scrollTo(0, 0)
	}

	render(){
		
		return(
			<PublicHomeView
				publicHomeImg01={publicHomeImg01}
				publicHomeImg02={publicHomeImg02}
				publicHomeImg03={publicHomeImg03}
				publicHomeImg04={publicHomeImg04}
				publicHomeImg05={publicHomeImg05}
				publicHomeImg06={publicHomeImg06}
			/>
		)

	}

}

export default PublicHome